<div class="alertbox error">
    <div class="icon">
        <img src="../../../../assets/img/icon/error.png" alt="Error">
    </div>
    <h4>{{"Warning" | translate}}</h4>
    <p><b>{{ "This transaction is not suitable for iframe usage." | translate }}</b></p>
    <div class="pButton"><button style="font-size: 1rem;" class="btn btn-success rounded" (click)="redirectToPayment()" type="submit"> {{'Please click to continue your transaction' | translate}} </button></div>
</div>